module.exports = __webpack_public_path__ + "img/pro_three_4.4385aa41.jpg";